import styled from 'styled-components';
import { flexAdaptiveSizeItem } from '../../../../themes/architecture/css-helpers/flex';
import {JACKPOT_WIDGET, RED_TIGER_JACKPOT} from '../../constants';

export const ListTitleTextDefaultBox = styled.div`
    position: relative;
    min-width: 28rem;
    max-width: 82.5%;
    text-transform: uppercase;
    padding: 0.5rem 2rem;
    font-size: 1.5rem;
    line-height: normal;
    margin: 0;
    background: ${props => props.theme.components.generalTitle.colors.background};
    border-left: 3px solid ${props => props.theme.colors.brandPrimary};
  
    letter-spacing: 0.2rem;
    display: flex;
    align-items: center;
  
    color: ${props => props.theme.components.gamesListTitle.colors.text.regular};
    ${({theme}) => theme.font.presets.bold};
  
  
    .${JACKPOT_WIDGET} & {
        color: ${props => props.theme.components.gamesListTitle.colors.text.dailyJackpot};
        border-left: 3px solid ${props => props.theme.components.gamesListTitle.colors.text.dailyJackpot};
    }

    .${RED_TIGER_JACKPOT} & {
        color: ${props => props.theme.components.gamesListTitle.colors.text.redTigerJackpot};
        border-left: 2px solid #ff014f;
    }

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
      padding: .9rem 2rem;
    }
  
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      min-width: 65%;
      max-width: 100%;
      padding: 0.6rem 0.1rem 0.6rem 2rem;
      font-size: 1.2rem;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      ${flexAdaptiveSizeItem}
      min-width: 0;
    }
`;
